
import { ALLOWED_DOMAINS } from '@/config/security';

export const isAllowedDomain = (url: string): boolean => {
  try {
    const urlObj = new URL(url);
    const hostname = urlObj.hostname.toLowerCase();
    
    // Check if the domain is in our allowed list
    return ALLOWED_DOMAINS.some(domain => {
      // Allow exact matches and subdomains
      return hostname === domain || hostname.endsWith(`.${domain}`);
    });
  } catch {
    // Invalid URL
    return false;
  }
};

export const sanitizeUrl = (url: string): string | null => {
  try {
    const urlObj = new URL(url);
    
    // Only allow HTTP and HTTPS protocols
    if (!['http:', 'https:'].includes(urlObj.protocol)) {
      return null;
    }
    
    // Check if domain is allowed
    if (!isAllowedDomain(url)) {
      console.warn(`Blocked navigation to disallowed domain: ${urlObj.hostname}`);
      return null;
    }
    
    return url;
  } catch {
    return null;
  }
};

export const secureOpenUrl = (url: string): void => {
  const sanitizedUrl = sanitizeUrl(url);
  
  if (!sanitizedUrl) {
    console.error('Attempted to open invalid or disallowed URL:', url);
    return;
  }
  
  // Open with security features
  const newWindow = window.open(sanitizedUrl, '_blank', 'noopener,noreferrer');
  
  if (newWindow) {
    // Clear the opener reference for additional security
    newWindow.opener = null;
  }
};
